/** @jsx jsx */
import { jsx, useTheme } from '@emotion/react';

import { Fragment } from 'react';

import useRouter from 'js/lib/useRouter';

import { Grid, PageGridContainer } from '@coursera/cds-core';

import EnterpriseSearch from 'bundles/enterprise-learner-search/components/search/EnterpriseSearch';
import SearchBreadcrumbs from 'bundles/enterprise-learner-search/components/search/SearchBreadcrumbs';
import SearchResultBanner from 'bundles/enterprise-learner-search/components/skillsetSearch/SearchResultBanner';
import { isSearchTheme } from 'bundles/search-common/searchTheme';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import { useThirdPartyOrganization } from 'bundles/unified-common/contexts/ThirdPartyOrganizationContext';

const EnterpriseSearchPageRootContent = () => {
  const theme = useTheme();
  const program = useProgram();
  const thirdPartyOrg = useThirdPartyOrganization();
  const router = useRouter();

  const {
    location: {
      query: { query: searchQuery },
    },
  } = router;

  if (!isSearchTheme(theme)) {
    throw new Error(
      'SearchPage can only be used in the context of a SearchTheme. Wrap this component with a ThemeProvider.'
    );
  }

  if (!program || !thirdPartyOrg) {
    return null;
  }

  return (
    <Fragment>
      <SearchBreadcrumbs
        programSlug={program.metadata?.slug}
        thirdPartyOrgSlug={thirdPartyOrg.slug}
        thirdPartyOrganizationId={thirdPartyOrg.id}
        programName={program.metadata?.name}
      />
      <main id="main" data-testid="SearchPageRoot" css={theme.searchPageContainer}>
        <div css={{ backgroundColor: 'white' }}>
          <PageGridContainer maxWidth="lg">
            <Grid item xs={12}>
              <SearchResultBanner
                thirdPartyOrgId={thirdPartyOrg.id}
                programSlug={program.metadata?.slug}
                programHomeLink={`/programs/${program.metadata?.slug}`}
                currentRefinement={searchQuery}
                programIds={[program.id]}
                showDivider={false}
              />
            </Grid>
          </PageGridContainer>
        </div>
        <div css={theme.mainContent}>
          <PageGridContainer maxWidth="lg">
            <Grid item xs={12}>
              <EnterpriseSearch
                programIds={[program.id]}
                thirdPartyOrganizationId={thirdPartyOrg.id}
                isEnterpriseSERP={true}
              />
            </Grid>
          </PageGridContainer>
        </div>
      </main>
    </Fragment>
  );
};

export default EnterpriseSearchPageRootContent;
